import { Controller } from "react-hook-form";
import {
  AdditionalFormFieldProps,
  FormField,
  SelectFieldProps,
} from "../common-types";
import SelectField from "./select-field";

const SelectFormField = (
  props: SelectFieldProps & AdditionalFormFieldProps & FormField
) => {
  const { name, control, defaultValue, options, multiple, customOnChange } =
    props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const handleChange = (newValue: any) => {
          if (customOnChange) customOnChange(newValue);
          onChange(newValue);
        };

        return (
          <SelectField
            {...props}
            options={options}
            value={value ? value : multiple ? [] : ""}
            onChange={handleChange}
            error={error}
            multiple={multiple}
          />
        );
      }}
    />
  );
};

export default SelectFormField;
